export const AddBeneficiaryStep = {
    'STEP1': 1,
    'STEP2': 2,
    'STEP3': 3,
    'Authy': 4,
};

